import "core-js/modules/es.array.push.js";
import "core-js/modules/es.iterator.constructor.js";
import "core-js/modules/es.iterator.find.js";
import { openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, Fragment as _Fragment, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, unref as _unref, normalizeStyle as _normalizeStyle } from "vue";
const _hoisted_1 = ["src"];
const _hoisted_2 = {
  key: 1,
  class: "cc-badges top-badges",
  style: {
    "position": "absolute",
    "top": "0.75rem",
    "left": "0.75rem",
    "z-index": "3"
  }
};
const _hoisted_3 = {
  class: "ccb"
};
const _hoisted_4 = {
  class: "cc-content"
};
const _hoisted_5 = {
  class: "cc-info"
};
const _hoisted_6 = {
  class: "cc-title"
};
const _hoisted_7 = {
  class: "cc-subtitle"
};
const _hoisted_8 = {
  class: "cc-badges"
};
const _hoisted_9 = {
  key: 0,
  class: "ccb",
  style: {
    "color": "#90c1cd"
  }
};
const _hoisted_10 = {
  key: 1,
  class: "ccb",
  style: {
    "color": "rgb(241, 204, 171)"
  }
};
import { computed } from "vue";
import { useRouter } from "vue-router";
import { toBigNumber } from "@/utils";
import { COMPETITION_STATUS } from "@/utils/constants";
export default {
  __name: 'CompetitionListItem',
  props: {
    index: {
      type: Number,
      required: true
    },
    competition: {
      type: Object,
      required: true
    }
  },
  setup(__props) {
    const $router = useRouter();
    const props = __props;

    // const emit = defineEmits(["sign-up", "submit-work", "to-create"]);

    const itemStyle = computed(() => {
      return {
        "animation-delay": (props.index % 3 + 1) * 0.04 + "s"
      };
    });
    const statusItem = computed(() => {
      return COMPETITION_STATUS.find(item => item.value === props.competition.status) || {
        value: props.competition.status,
        label: props.competition.status_label
      };
    });

    // const deadlineDiffDays = computed(() => {
    //   if (props.competition.target_time == null) {
    //     return null;
    //   }
    //   const diffDays = dayjs(props.competition.target_time).diff(dayjs(), "days") + 1;
    //   return {
    //     diffDays,
    //     // deadlineDate: props.competition.deadline.format("YYYY.MM.DD"),
    //     isUrgent: diffDays > 0 && diffDays <= 7,
    //     text: diffDays === 0 ? "今天" : diffDays > 0 ? diffDays + "天后" : dayjs(props.competition.target_time).format("YYYY.MM.DD"),
    //   };
    // });

    const toDetail = () => {
      $router.push({
        name: "competition-detail",
        query: {
          id: props.competition.contest_id || 1
        }
      });
    };

    // const signUp = () => {
    //   emit("sign-up");
    // };

    // const submitWork = () => {
    //   emit("submit-work");
    // };

    return (_ctx, _cache) => {
      return _openBlock(), _createElementBlock("div", {
        class: "cc",
        style: _normalizeStyle(itemStyle.value),
        onClick: toDetail
      }, [__props.competition.cover_image ? (_openBlock(), _createElementBlock(_Fragment, {
        key: 0
      }, [__props.competition.cover_image.includes('http') ? (_openBlock(), _createElementBlock("img", {
        key: 0,
        class: "cc-img",
        src: __props.competition.cover_image
      }, null, 8, _hoisted_1)) : _createCommentVNode("", true)], 64)) : _createCommentVNode("", true), statusItem.value?.label ? (_openBlock(), _createElementBlock("div", _hoisted_2, [_createElementVNode("div", _hoisted_3, _toDisplayString(statusItem.value.label), 1)])) : _createCommentVNode("", true), _cache[0] || (_cache[0] = _createElementVNode("div", {
        class: "cc-vignette absolute bottom-0 left-0 right-0 h-[140px] backdrop-blur-[12px]",
        style: {}
      }, null, -1)), _createElementVNode("div", _hoisted_4, [_createElementVNode("div", _hoisted_5, [_createElementVNode("div", _hoisted_6, _toDisplayString(__props.competition.title), 1), _createElementVNode("div", _hoisted_7, _toDisplayString(__props.competition.sub_title), 1)]), _createElementVNode("div", _hoisted_8, [!!__props.competition.bonus_pool_amount ? (_openBlock(), _createElementBlock("div", _hoisted_9, "超 ¥" + _toDisplayString(_unref(toBigNumber)(__props.competition.bonus_pool_amount)) + " 奖金", 1)) : _createCommentVNode("", true), !!__props.competition.organizer ? (_openBlock(), _createElementBlock("div", _hoisted_10, _toDisplayString(__props.competition.organizer), 1)) : _createCommentVNode("", true)])])], 4);
    };
  }
};